import i18n from '../../../locales/i18n'
import store from '../../../admin/store'

export const friendshipStateLookup = user => {
    const {
        friendship_state,
        friendship_type,
    } = user.friendship ? user.friendship.data : user.sportnectionStatus.data

    let data = {}

    switch (friendship_state) {
        case 1:
            data = {
                text: friendship_type === 'in' ? i18n.t('sportnectionsStatus.waiting') : i18n.t('sportnectionsStatus.requestSended'),
                state: 1,
            }
            break
        case 2:
            data = {
                text: i18n.t('sportnectionsStatus.connected'),
                state: 2,
            }
            break
        case 3:
            data = {
                text: i18n.t('sportnectionsStatus.refused'),
                state: 3,
            }
            break
        case 4:
            data = {
                text: i18n.t('sportnectionsStatus.canceled'),
                state: 4,
            }
            break
        default:
            data = {
                text: i18n.t('sportnectionsStatus.request'),
                state: null,
            }
            break
    }

    data.friendshipType = friendship_type
    return data
}

export const callSetFriendshipStatus = (user, newStatus = 0, confirmMessage = null, loader = null) => {
    if (confirmMessage !== null) {
        return new Promise((resolve, reject) => {
            window.swconfirm({
                title: confirmMessage,
                onConfirm: () => {
                    if (loader) {
                        loader.setLoader(loader.loader, true)
                    }

                    return window.axios.put(
                        `${window.APP_CONFIG.REACT_APP_API_URL}api/users/me/sportnections/status?include=friendshipId`, {
                            status: newStatus === 0 ? 1 : newStatus,
                            user: user.id,
                        }).then(response => resolve(response))
                },
                onCancel: () => {
                    reject()
                }
            })
        })
    }

    return window.axios.put(
        `${window.APP_CONFIG.REACT_APP_API_URL}api/users/me/sportnections/status?include=friendshipId`, {
            status: newStatus === 0 ? 1 : newStatus,
            user: user.id,
        }
    )
}

/**
 * Set friendship status to specific user
 *
 * @param {Object} props
 * @param {Integer} actualStatus
 * @param {Integer} newStatus
 * @param {string} confirmMessage
 * @return {Promise}
 */
export const setStatus = (props, actualStatus, newStatus, confirmMessage) => {
    const {
        user,
        searchUsers,
        requests,
        sportnections,
        loader,
        setLoader,
        successReload,
        context,
        successCallback,
        users: {
            data: usersData,
        },
    } = props

    const friendshipStatusData = {
        actualStatus,
        user: user,
        newStatus,
        confirmMessage,
        loader: loader || {
            setLoader: setLoader,
            loader: 'loader',
        },
        requests: requests,
        sportnections: sportnections,
        searchUsers: searchUsers && searchUsers.length > 0 ? searchUsers : usersData,
    }

    return setFriendshipStatus(friendshipStatusData)
        .then(data => {
            if (successReload === true && actualStatus) {
                window.location.reload()
            }

            if (!actualStatus) {
                return new Promise(resolve => resolve(data))
            }

            if (successCallback && typeof successCallback === 'function') {
                successCallback()
                return new Promise(resolve => resolve())
            }

            if (context) {
                context.setState({
                    requests: data.requests,
                    sportnections: data.sportnections,
                    searchUsers: data.searchUsers,
                })
            }

            if (usersData && usersData.length) {

                const updatedUser = usersData.findIndex(_user => _user.id === user.id)

                let usersDataStore = [ ...usersData ]
                usersDataStore[updatedUser] = user

                store.dispatch({
                    type: 'USERS_SET_DATA',
                    data: {
                        data: usersDataStore,
                    },
                })
            }

            return new Promise(resolve => resolve(data))
        })
        .catch(() => {})
}

export const setFriendshipStatus = props => {
    let {
        actualStatus, user, newStatus, confirmMessage, loader, requests, sportnections, searchUsers,
    } = props

    searchUsers = searchUsers || []
    sportnections = sportnections || []
    requests = requests || []
    newStatus = newStatus || 0
    confirmMessage = confirmMessage || null

    const caller = callSetFriendshipStatus(user, newStatus, confirmMessage, loader)

    return new Promise((resolve, reject) => {
        caller.then(apiResponse => {
            let resRequests = requests
            let resSportnections = sportnections
            let resSearchUsers = []

            switch (actualStatus) {
                case 1:
                    if (newStatus === 3 || newStatus === 4) {
                        resSearchUsers = setStatusToSearchUser(newStatus, user, searchUsers)

                        let newRequests = []

                        for (let request in requests) {
                            if (requests[request].id !== user.id) {
                                newRequests.push(requests[request])
                            }
                        }

                        resRequests = newRequests
                    }

                    if (newStatus === 2) {
                        resSearchUsers = setStatusToSearchUser(newStatus, user, searchUsers)

                        let newRequests = []

                        for (let request in requests) {
                            if (requests[request].id !== user.id) {
                                newRequests.push(requests[request])
                            } else {
                                sportnections.push(requests[request])
                            }
                        }
                        resSportnections = sportnections
                        resRequests = newRequests
                    }
                    break
                case 2:
                    if (newStatus === 4) {
                        resSearchUsers = setStatusToSearchUser(newStatus, user, searchUsers)

                        let newSportnections = []

                        for (let sportnection in sportnections) {
                            if (sportnections[sportnection].id !== user.id) {
                                newSportnections.push(sportnections[sportnection])
                            }
                        }

                        resSportnections = newSportnections
                    }
                    break
                case 3:
                    resSearchUsers = setStatusToSearchUser(1, user, searchUsers)
                    break
                case 4:
                    resSearchUsers = setStatusToSearchUser(1, user, searchUsers)
                    break
                default:
                    resSearchUsers = setStatusToSearchUser(newStatus === 0 ? 1 : newStatus, user, searchUsers)
                    break
            }

            if (loader) {
                loader.setLoader(loader.loader, false)
            }

            resolve({
                requests: resRequests,
                sportnections: resSportnections,
                searchUsers: resSearchUsers,
                apiResponse,
            })
        }).catch(() => reject())
    })

}

export const setStatusToSearchUser = (status, user, searchUsers) => {
    const findUserSearch = Object.values(searchUsers).findIndex(u => u.id === user.id)

    if (findUserSearch !== -1) {
        searchUsers[findUserSearch].friendship.data.friendship_state = status
        searchUsers[findUserSearch].friendship.data.friendship_type = 'out'
    }

    return searchUsers
}
